<template>
  <div class="sidebar-page">
    <TopBar />
    <div class="content">

      <!-- Menu lateral -->
      <aside class="sidebar">
        
        <h2>Avaliação de Controles Internos</h2>
        
        <ul>
          <li @click="navigateTo('home')">Inicio</li>
          <li @click="navigateTo('all-control-points')">Minhas Tarefas</li>
            <li @click="navigateTo('all-control-points')" style="padding-left: 50px;">Pontos de Controle</li>
            <li @click="navigateTo('pending-control-points')" style="padding-left: 50px;">Pontos de Controle Pendentes</li>
            <li @click="navigateTo('answered-control-points')" style="padding-left: 50px;">Pontos de Controle Respondidos</li>
          <li :class="{ 'selected': true }" @click="navigateTo('obligations-calendar')">Calendário de obrigações</li>
        </ul>

      </aside>

      <!-- Conteúdo: Escopo e Questões -->
      <main class="main-content">
        <CalendarWidget/>
      </main>

    </div>
  </div>
</template>

<script setup>

  import CalendarWidget from '@/components/dashboard/CalendarWidget.vue';
import TopBar from '@/components/TopBar.vue';
import { onMounted, ref } from 'vue';
import { onBeforeRouteUpdate, useRouter } from 'vue-router';

  const answered = ref(null);
  const selectedMenuItem = ref('home');
  var router = useRouter();


  onMounted(() => {
    // Verifica se há um menuItem na rota atual
    if (typeof router.currentRoute.value.params.menuItem === 'string') {
      navigateTo(router.currentRoute.value.params.menuItem);
    }
  });
  
  onBeforeRouteUpdate((to, from, next) => {
    if (typeof to.params.menuItem === 'string') {
      selectedMenuItem.value = to.params.menuItem;
    }
    next();
  });

  const navigateTo = (menuItem) => {
    selectedMenuItem.value = menuItem;

    // // Atualizar a variável answered com base na opção selecionada
    if (menuItem === 'pending-control-points') {
      answered.value = false;
    } else if (menuItem === 'answered-control-points') {
      answered.value = true;
    } else {
      answered.value = null;
    }

    if (menuItem === 'home') {
      router.push({ name: 'home' });
    } 
    else if (menuItem == 'obligations-calendar') {
      router.push({ name: 'obligationsCalendar' });
    }
    else {
      router.push({ name: 'MainPage', params: { menuItem } });
    }
  };

</script>

<style scoped>

  .sidebar-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .content {
    display: flex;
    flex: 1;
  }

  .sidebar {
    width: 20%;
    background-color: #f8f9fa;
    padding: 1rem;
    border-right: 1px solid #dee2e6;
  }

  .sidebar h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .sidebar ul {
    list-style: none;
    padding: 0;
  }

  .sidebar ul li {
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 0.25rem;
    transition: background-color 0.2s;
  }

  .sidebar ul li:hover {
    background-color: #e9ecef;
  }

  .selected {
    background-color: #e9ecef;
    font-weight: bold;
  }

  .main-content {
    flex: 1;
    padding: 1rem;
  }

</style>
